import Inserr from './Inserr';
export default Inserr;